import React from 'react';
import WhatsAppButton from './WhatsAppButton';
import ChatAssistant from './ChatAssistant';
import Testimonials from './Testimonials';
import Comparador from './Comparador';
import LandingHeader from './landing/LandingHeader';
import HeroSection from './landing/HeroSection';
import NewsletterForm from './landing/NewsletterForm';
import PartnersSection from './landing/PartnersSection';
import FeaturesSection from './landing/FeaturesSection';
import CtaSection from './landing/CtaSection';
import LandingFooter from './landing/LandingFooter';
import FaqSection from './landing/FaqSection';
import BlogSection from './landing/BlogSection';
import { trackClick } from './landing/constants';

const NewsletterLanding = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
    <LandingHeader />
    <HeroSection />
    <Comparador onTrackClick={trackClick} />
    <Testimonials />
    <FaqSection />
    <NewsletterForm />
    <PartnersSection />
    <FeaturesSection />
    <BlogSection />
    <CtaSection />
    <LandingFooter />
    <WhatsAppButton onClick={() => trackClick('WhatsApp')} />
    <ChatAssistant />
    <style>{`
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-20px); }
      }
      .animate-float { animation: float 3s ease-in-out infinite; }
    `}</style>
  </div>
);

export default NewsletterLanding;
